import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  numberAttribute,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ERROR_LEVEL_MAP, QrGeneratorService } from '@core/services';

@Component({
  standalone: true,
  selector: 'cheelee-qr',
  templateUrl: './qr.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('canvas', { static: false }) canvas!: ElementRef<HTMLCanvasElement>;

  @Input({ required: true }) value!: string;

  @Input() level: keyof typeof ERROR_LEVEL_MAP = 'M';

  @Input({ transform: numberAttribute }) padding = 10;

  @Input() color = '#ffffff';

  @Input() bgColor = 'transparent';

  @Input({ transform: numberAttribute }) size = 150;

  private readonly elRef = inject(ElementRef);

  private readonly qrGeneratorService = inject(QrGeneratorService);

  ngOnChanges(changes: SimpleChanges): void {
    const { value, level, padding, color, bgColor, size } = changes;

    if ((value || level || padding || color || bgColor || size) && this.canvas) {
      this.drawCanvas();
    }

    if (bgColor) {
      this.setElBg();
    }
  }

  ngOnInit(): void {
    this.setElBg();
  }

  ngAfterViewInit(): void {
    this.drawCanvas();
  }

  setElBg(): void {
    this.elRef.nativeElement.style.backgroundColor = this.bgColor;
  }

  drawCanvas(): void {
    if (this.canvas) {
      this.qrGeneratorService.drawCanvas(
        this.canvas.nativeElement,
        this.qrGeneratorService.plotQRCodeData(this.value, this.level),
        this.size,
        10,
        this.padding,
        this.color,
        this.bgColor,
      );
    }
  }
}
